import { LuCirclePlus, LuHash, LuMessagesSquare, LuSearch } from 'react-icons/lu';
import { moduleTour as tour, OPTIONAL as opt } from '../defineTour';

// Landing-tab tour first; one tour per further tab below it.
const tours = [
  tour('huddle', '/huddle', 'huddle', [
    ['channels', 'huddle.channels', LuHash, { placement: 'right' }],
    ['search', 'huddle.search', LuSearch, { placement: 'right' }],
    ['new', 'huddle.new', LuCirclePlus, { placement: 'right', ...opt }],
    ['messages', 'huddle.messages', LuMessagesSquare, { placement: 'left', padding: 0 }],
  ]),
];

export default tours;
